export const TEMPLATES_REDUCER_NAME = 'templates'
export const TEMPLATES_LIST_REDUCER_NAME = 'templatesList'
export const DELETE_TEMPLATE_REDUCER_NAME = 'deleteTemplate'

export enum TEMPLATES_HEADERS {
  NAME = 'name',
  UPLOADED = 'uploaded',
  INTEGRATOR_NAME = 'integratorName',
  VERSION = 'version',
  DOWNLOAD_LINK = 'downloadLink',
  ID = 'id',
}
